import styled from "styled-components";

const SmallTextStyles = styled.p`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.body.b2.weight};
  font-size: ${({ theme }) => theme.typography.body.b2.size};
  line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
  color: ${({ theme }) => theme.colors.semantic.text.strong};
`;

const SmallText = ({ children, className, style }) => (
  <SmallTextStyles className={className} style={{ ...style }}>
    {children}
  </SmallTextStyles>
);

export default SmallText;
